module.exports = __webpack_public_path__ + "media/images/FootprintGlobe-2218820c.svg";